/** @format */

import React, { useRef, useState } from "react";
import { observer } from "mobx-react";

import {
  Flex,
  Image,
  Link,
  Button,
  useMediaQuery,
  Stack,
  Center
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import theme from "@src/style/theme";
import { useStores } from "@src/hooks/useStores";
import colors from "@src/style/colors";
import { Language } from "@src/stores/Settings";
import { useNavigate, useLocation } from "react-router-dom";

export const Navbar: React.FC = observer(() => {
  const { settings } = useStores();
  const navigate = useNavigate();
  const location = useLocation();

  const [isMedium] = useMediaQuery([`(min-width: ${theme.breakpoints.md})`]);
  const test = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    navigate("/");
  };

  return (
    <Flex
      position={"sticky"}
      justifyContent={"center"}
      alignItems={"center"}
      zIndex={"dropdown"}
      top={"0"}
      width={"100%"}
      paddingX={{
        base: "20px",
        sm: "20px",
        md: "65px",
        lg: "108px"
      }}
      boxShadow={"sm"}
      backgroundColor={"white"}
    >
      <Flex
        maxWidth={theme.breakpoints.mx}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        height={{ base: "44px", sm: "68px", md: "76px", lg: "100px" }}
      >
        <Link onClick={test} style={{ textDecoration: "none" }}>
          <Image
            height={{ base: "22px", sm: "34px", md: "24px", lg: "32px" }}
            src={commonInfo.logo.sandbank.image}
          />
        </Link>
        {isMedium ? (
          <Flex
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Stack
              direction={"row"}
              spacing={{
                md: "22px",
                lg: "40px"
              }}
              fontSize={{
                base: "14px",
                md: "14px",
                lg: "18px"
              }}
              fontWeight={500}
              align={"center"}
              color={colors.black}
            >
              <Link
                _hover={{
                  textDecoration: "underline",
                  textDecorationThickness: "2px",
                  textUnderlineOffset: "5px",
                  textDecorationColor: colors.blue,
                  opacity: "0.7"
                }}
                style={{ transition: "opacity 0.3s" }}
                href={"https://medium.com/sandbank-kr"}
                isExternal
              >
                {settings.language === Language.korean
                  ? "공지사항"
                  : "Announcements"}
              </Link>
              <Link
                _hover={{
                  textDecoration: "underline",
                  textDecorationThickness: "2px",
                  textUnderlineOffset: "5px",
                  textDecorationColor: colors.blue,
                  opacity: "0.7"
                }}
                style={{ transition: "opacity 0.3s" }}
                onClick={() => {
                  navigate("/about");
                }}
              >
                {settings.language === Language.korean ? "회사소개" : "Company"}
              </Link>
              <Link
                _hover={{
                  textDecoration: "underline",
                  textDecorationThickness: "2px",
                  textUnderlineOffset: "5px",
                  textDecorationColor: colors.blue,
                  opacity: "0.7"
                }}
                style={{ transition: "opacity 0.3s" }}
                onClick={() => {
                  settings.setDirectingQnA();
                  navigate("/");
                }}
              >
                {settings.language === Language.korean
                  ? "자주 묻는 질문"
                  : "FAQ"}
              </Link>
              <Link
                _hover={{
                  textDecoration: "underline",
                  textDecorationThickness: "2px",
                  textUnderlineOffset: "5px",
                  textDecorationColor: colors.blue,
                  opacity: "0.7"
                }}
                style={{ transition: "opacity 0.3s" }}
                href={"https://transfer.sandbank.io"}
                isExternal
              >
                {settings.language === Language.korean
                  ? "출금 신청"
                  : "Withdrawal"}
              </Link>
              <Flex
                flexDirection={"row"}
                justifyContent={"center"}
                alignItems={"baseline"}
                bgColor={colors.lightGray}
                borderRadius={"1000px"}
                overflow={"hidden"}
                paddingX={"15px"}
              >
                <Button
                  variant={"unstyled"}
                  width={"50%"}
                  fontSize={{
                    base: "14px",
                    md: "12px",
                    lg: "14px"
                  }}
                  fontWeight={settings.language === Language.korean ? 600 : 400}
                  color={colors.black}
                  onClick={() => {
                    settings.setLanguage(Language.korean);
                  }}
                >
                  KOR
                </Button>
                <Button
                  variant={"unstyled"}
                  width={"50%"}
                  fontSize={{
                    base: "14px",
                    md: "12px",
                    lg: "14px"
                  }}
                  flexShrink={1}
                  fontWeight={
                    settings.language === Language.english ? 600 : 400
                  }
                  color={colors.black}
                  onClick={() => {
                    settings.setLanguage(Language.english);
                  }}
                >
                  ENG
                </Button>
              </Flex>
            </Stack>
          </Flex>
        ) : (
          <Button
            colorScheme={colors.black}
            variant={"unstyled"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Center>
              <Image
                width={"32px"}
                height={"32px"}
                src={commonInfo.btn.image}
                onClick={() => {
                  settings.setSidebar();
                }}
              />
            </Center>
          </Button>
        )}
      </Flex>
    </Flex>
  );
});

export default Navbar;
